// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailsRow_wrapper__8XIht","title":"DetailsRow_title__Df8AL","value":"DetailsRow_value__IFesq"};